// extracted by mini-css-extract-plugin
export var divider = "_ju-0";
export var systemMessage = "_ju-1";